// extracted by mini-css-extract-plugin
module.exports = {"root":"Overlay-root-2pdBR","table":"Overlay-table-3zUWK","cell":"Overlay-cell-18RrS"};